export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 3.5a1 1 0 011 1v15a1 1 0 01-1 1h-17a1 1 0 01-1-1v-15a1 1 0 011-1h17zm-16 15h15v-13h-15v13z\" fill=\"#7B61FF\"/><path d=\"M10.58 13.216v3H8.576V7.6h3.636c2.028 0 3.288.96 3.288 2.808 0 1.836-1.26 2.808-3.288 2.808H10.58zm0-1.68h1.524c.948 0 1.428-.42 1.428-1.128s-.48-1.116-1.428-1.116H10.58v2.244z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};